import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import CursorDot from "@/components/CursorDot";
import useLenis from "@/hooks/useLenis";
import Landing from "@/pages/Landing";
import Work from "@/pages/Work";
import ProjectDetail from "@/pages/ProjectDetail";
import Studio from "@/pages/Studio";
import Process from "@/pages/Process";
import Journal from "@/pages/Journal";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/AdminLayout";
import AdminProjects from "@/pages/AdminProjects";
import AdminLeads from "@/pages/AdminLeads";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function PublicShell({ children }) {
  return (
    <div className="grain">
      <Nav />
      {children}
      <Footer />
    </div>
  );
}

function AppRoutes() {
  const loc = useLocation();
  const isAdmin = loc.pathname.startsWith("/admin");
  useLenis();
  useEffect(() => {
    if (isAdmin) {
      document.body.classList.remove("cursor-hidden");
    } else {
      document.body.classList.add("cursor-hidden");
    }
    return () => document.body.classList.remove("cursor-hidden");
  }, [isAdmin]);
  return (
    <>
      <ScrollTop />
      {!isAdmin && <CursorDot />}
      <Toaster position="bottom-right" toastOptions={{ style: { fontFamily: "Manrope, sans-serif" } }} />
      <Routes>
        <Route path="/" element={<PublicShell><Landing /></PublicShell>} />
        <Route path="/work" element={<PublicShell><Work /></PublicShell>} />
        <Route path="/work/:id" element={<PublicShell><ProjectDetail /></PublicShell>} />
        <Route path="/studio" element={<PublicShell><Studio /></PublicShell>} />
        <Route path="/process" element={<PublicShell><Process /></PublicShell>} />
        <Route path="/journal" element={<PublicShell><Journal /></PublicShell>} />
        <Route path="/contact" element={<PublicShell><Contact /></PublicShell>} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminProjects />} />
          <Route path="leads" element={<AdminLeads />} />
        </Route>
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </div>
  );
}
